export default __webpack_public_path__ + "ee47ea1.png";